import type { ManagedApiRequest } from './types';

export const getApiMeasureName = ({ apiName, body, requestType }: ManagedApiRequest): string =>
  requestType === 'Graphql' && body != null && typeof body === 'object' && 'operationName' in body
    ? String(body.operationName)
    : (apiName ?? 'unknown_api');
